function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.06 299.085L4 452.615l43.33 5.06 200-4.31-24.27-445.28-8.06-1V0H33l-.94 299.085zm50.69-22.38l-5.36 95.7h53.58l-10.72-78.81-16.07-16.89H82.75z",
  fill: "#8585FF"
});

function SvgBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 274 458",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjc0IDQ1OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMyLjA2IDI5OS4wODVMNCA0NTIuNjE1bDQzLjMzIDUuMDYgMjAwLTQuMzEtMjQuMjctNDQ1LjI4LTguMDYtMVYwSDMzbC0uOTQgMjk5LjA4NXptNTAuNjktMjIuMzhsLTUuMzYgOTUuN2g1My41OGwtMTAuNzItNzguODEtMTYuMDctMTYuODlIODIuNzV6IiBmaWxsPSIjODU4NUZGIi8+Cjwvc3ZnPg==";
export { SvgBottom as ReactComponent };